import { Routes } from '@angular/router';
import { CreditApplicationComponent } from './credit-application/credit-application.component';
import { RegistrationFormComponent } from './registration-form/registration-form.component';
import { OtpVerificationComponent } from './otp-verification/otp-verification.component';
import { PersonalDataComponent } from './personal-data/personal-data.component';
import { AddressPersonalComponent } from './address-personal/address-personal.component';
import { BusinessDataComponent } from './business-data/business-data.component';
import { LoanUseComponent } from './loan-use/loan-use.component';
import { FirstPersonalReferenceComponent } from './first-personal-reference/first-personal-reference.component';
import { SecondPersonalReferenceComponent } from './second-personal-reference/second-personal-reference.component';
import { AdditionalDataComponent } from './additional-data/additional-data.component';
import { VerifyIdentityComponent } from './verify-identity/verify-identity.component';
import { VerificationModuleComponent } from './verification-module/verification-module.component';
import { UploadDocumentsComponent } from './upload-documents/upload-documents.component';
import { CreditHistoryComponent } from './credit-history/credit-history.component';
import { PendingEvaluationComponent } from './pending-evaluation/pending-evaluation.component';

export const routes: Routes = [
  { path: '', redirectTo: '/welcome', pathMatch: 'full' },
  { path: 'welcome', component: CreditApplicationComponent },
  { path: 'registration', component: RegistrationFormComponent },
  { path: 'otp', component: OtpVerificationComponent },
  { path: 'personal-data', component: PersonalDataComponent },
  { path: 'address-personal', component: AddressPersonalComponent },
  { path: 'business-data', component: BusinessDataComponent },
  { path: 'loan-use', component: LoanUseComponent },
  { path: 'first-reference', component: FirstPersonalReferenceComponent },
  { path: 'second-reference', component: SecondPersonalReferenceComponent },
  { path: 'additional-data', component: AdditionalDataComponent },
  { path: 'verify-identity', component: VerifyIdentityComponent },
  { path: 'verification-module', component: VerificationModuleComponent },
  { path: 'upload-documents', component: UploadDocumentsComponent },
  { path: 'credit-history', component: CreditHistoryComponent },
  { path: 'pending-evaluation', component: PendingEvaluationComponent },
  { path: '**', redirectTo: '/welcome' } // Wildcard route para rutas no encontradas
];